import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SelosComponent} from "../componentes/selo/selo.component";
import {DropDownFilterSettings} from "@progress/kendo-angular-dropdowns";
import {ContatosService} from "../services/contatos.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {AutorizacaoService} from "../services/autorizacao.service";

import {ConstantsService} from "../fidelidade/ConstantsService";
import {ArmazenamentoService} from "../services/armazenamento.service";
import {BotsService} from "../services/bots.service";
import {Subscription} from "rxjs";
import {DiagnosticoWhatsappService} from "../services/diagnostico-whatsapp.service";
import {ImpressaoService} from "../services/impressao.service";
import {SuporteWhatsappService} from "../services/suporte-whatsapp.service";
import {SuporteContatosWhatsappService} from "../services/suporte-contatos-whatsapp.service";
import {WhatsappService} from "../services/whatsapp.service";
import {UsuarioService} from "../services/usuario.service";

// Interface para os itens do log
interface LogItem {
  timestamp: Date;
  tempoRelativo: string;
  tipo: 'INFO' | 'WARNING' | 'ERROR' | 'SUCCESS';
  categoria: 'PROCESSAMENTO' | 'VALIDACAO' | 'ENVIO' | 'SISTEMA';
  icone: string;
  iconeCategoria: string;
  nome: string;
  telefone: string;
  mensagem: string;
  textoMensagem?: string;
  tipoMensagem?: string;
  detalhes?: any;
  detalhesFormatados?: string;
  cssClass: string;
  expanded?: boolean;
}

@Component({
  selector: 'app-ver-contato-iframe',
  templateUrl: './ver-contato-iframe.component.html',
  styleUrls: ['./ver-contato-iframe.component.scss']
})
export class VerContatoIframeComponent implements OnInit, OnDestroy {
  acoes: any = [];
  cartoes: any = [];
  filtro: any = {cartao: null};
  contato: any = null;
  @ViewChild('selosCartao', { static: true } ) selosCartao: SelosComponent;
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains'
  };
  abraDialogo: boolean;
  telefone: any;
  nomeContato: any;
  widget = false;
  usuario: any;
  empresa: any;
  modoSuporte = false;
  salvandoAssinaturaWhatsapp = false;
  suporteContatoContexto: any;
  suporteContatoErro = '';
  suporteContatoCarregando = false;
  suporteContatoSalvando = false;
  suporteContatoDesvinculando = false;
  suporteContatoExibindoDesvincular = false;
  suporteContatoJustificativaDesvinculo = '';
  suporteContatoEditando = false;
  suporteContatoBuscandoEmpresas = false;
  suporteContatoBuscouEmpresas = false;
  suporteContatoTermoEmpresa = '';
  suporteContatoEmpresas: any[] = [];
  suporteContatoEmpresaSelecionada: any;
  suporteContatoUsuariosEmpresa: any[] = [];
  suporteContatoForm: any = { funcao: 'OUTRO', usuarioEmpresaId: null };
  pedidosEmAberto: any[];
  pedidosAnteriores: any[];
  carregou: boolean;
  novoPedido: any = {}
  msg: any = '';
  dev = false;
  assumirComandoBot: any;
  atendente = false;
  desativarParaSempre = false;
  statusMia = false;
  contatoPorDados: any = {};
  assinante: Subscription;
  assinantesRotaSuporte: Subscription[] = [];
  impressorasConfiguradas: any[] = [];
  private timeoutBuscaEmpresasSuporte: any;
  private numeroContextoContatoSuporte = 0;
  private numeroBuscaContatoSuporte = 0;
  private chaveContextoContatoSuporte = '';

  // Propriedades para controlar a exibição do relatório na tela
  exibirRelatorioNaTela = false;
  conteudoRelatorio = '';
  conteudoRelatorioFormatado = '';
  tituloRelatorio = '';
  dataGeracaoRelatorio = '';

  // Propriedades para o ListView
  logsListView: LogItem[] = [];
  logsListViewFiltrados: LogItem[] = [];
  filtroTipo: string = 'TODOS';
  filtroCategoria: string = 'TODAS';
  textoBusca: string = '';
  totalLogs: number = 0;
  estatisticas = {
    sucessos: 0,
    erros: 0,
    avisos: 0,
    processamentos: 0
  };

  constructor(  private  contatosService: ContatosService, private router: Router,
               private activatedRoute: ActivatedRoute, private _location: Location,
               private autorizacaoService: AutorizacaoService, private constantsService: ConstantsService,
               private armazenamentoService: ArmazenamentoService, private botsService: BotsService,
               private diagnosticoWhatsappService: DiagnosticoWhatsappService,
               private impressaoService: ImpressaoService,
               private suporteWhatsappService: SuporteWhatsappService,
               private suporteContatosWhatsappService: SuporteContatosWhatsappService,
               private whatsappService: WhatsappService,
               private usuarioService: UsuarioService) {
    this.dev = (window.location.href.indexOf('localhost') !== -1);
    this.widget = this.inIframe();
  }

  inIframe () {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  calculeSeBotEstahAtivo(telefone: string) {
    if( this.modoSuporte || !this.usuario || !telefone ) {
      return;
    }

    this.botsService.estahComAtedente(this.empresa, telefone).then( (respSessao: any) => {
      this.atendente = respSessao.data.atendente;
      this.desativarParaSempre = respSessao.data.desativarParaSempre;

      const configuracoesMia = respSessao.data.mia;

      if( configuracoesMia ) {
        this.statusMia = (configuracoesMia.status !== 'DESATIVADA');
      }
    });
  }

  ngOnInit() {
    this.msg = this.activatedRoute.snapshot.queryParams.msg;
    this.novoPedido = { guid: this.activatedRoute.snapshot.queryParams.codigo};

    let usuarioLogado = this.autorizacaoService.getUser();

    if( usuarioLogado != null )
      this.usuario = usuarioLogado;
    else {
      this.usuario = {};
    }
    this.notifiqueExtensaoAssinarMensagens();

    this.autorizacaoService.usuarioLogado$.subscribe( (usuario) => {
      if( !usuario ) return;

      this.usuario = usuario;
      this.notifiqueExtensaoAssinarMensagens();
      if( this.atualizeModoSuporte() ) {
        this.prepareModoSuporteIndividual();
      }
    });

    this.assinantesRotaSuporte.push(
      this.activatedRoute.params.subscribe(() => this.prepareModoSuporteIndividualSeAtivo()),
      this.activatedRoute.queryParams.subscribe(() => this.prepareModoSuporteIndividualSeAtivo())
    );

    const gerarLinkPagamento  = this.activatedRoute.snapshot.queryParams.gmlkpg;

    //gerar msg link pagamento
    if(gerarLinkPagamento)
      window['root'].envieMensagemLinkPagamento(gerarLinkPagamento);



    this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa ) { return; }

      this.empresa = empresa;
      if( this.atualizeModoSuporte() ) {
        this.prepareModoSuporteIndividual();
        return;
      }

      this.carregueImpressorasConfiguradas();

      this.assinante = this.botsService.eventoEstadoMia$.subscribe( (dados: any) => {
        if( this.contato ) {
          this.calculeSeBotEstahAtivo(this.contato.codigoPais + this.contato.telefone);
        }
      });

      this.activatedRoute.queryParams.subscribe(queryParams => {
        this.nomeContato = this.activatedRoute.snapshot.queryParams.nome;

        if( this.nomeContato === 'undefined' || this.nomeContato === undefined ) {
          this.nomeContato = '';
        }

        this.widget = this.inIframe();

        const { contato } = window.history.state;

        if (contato) {
          this.setContato(contato);
        }
        else {
          this.telefone = decodeURIComponent(this.activatedRoute.snapshot.params['zap']);
          this.contatoPorDados = this.gereNovoContato(this.nomeContato, this.telefone)
          this.contatosService.obtenhaContato(this.telefone.toString()).then( (objContato: any) => {
            this.setContato(objContato);
          });
        }

        this.calculeSeBotEstahAtivo(this.activatedRoute.snapshot.params['zap']);
      });
    });
  }

  salveContato(contato: any) {
    this.contato = contato;
  }

  gereNovoContato(nomeContato: string, telefoneCompleto: string) {

    const { codigoPais, telefone } = this.contatosService.extraiCodigoPaisETelefone(telefoneCompleto)

    return { nome: nomeContato,
      codigoPais: codigoPais,
      telefone: telefone
    }
  }


  setContato(contato: any) {
    if( this.modoSuporte ) {
      return;
    }

    this.contato = contato;

    let estadoAnterior: any = JSON.parse(this.armazenamentoService.carregue('url_' + this.telefone))  ;

    if(estadoAnterior) {
      this.router.navigateByUrl(estadoAnterior.url, {state: estadoAnterior.state});
      return;
    }

    this.carregou = true;
    if( !contato ) {
      return;
    }

    this.cartoes = contato.cartoes;
    this.cartoes.forEach( cartao => cartao.descricao = cartao.plano.nome)
  }

  voltar() {
    this._location.back();
  }

  recarregue() {
    window.location.reload();
  }

  private atualizeModoSuporte(): boolean {
    this.modoSuporte = Number(this.empresa && this.empresa.id) === 1 &&
      !!(this.usuario && (this.usuario.admin || this.usuario.superadmin));

    return this.modoSuporte;
  }

  salveAssinaturaWhatsapp() {
    this.salvandoAssinaturaWhatsapp = true;
    this.suporteContatoErro = '';

    this.usuarioService.salveAssinatura(this.usuario.assinarMensagens).then(() => {
      this.autorizacaoService.atualizeUsuario(this.usuario);
      this.notifiqueExtensaoAssinarMensagens();
    }).catch(erro => {
      this.suporteContatoErro = erro || 'Não foi possível salvar a assinatura das mensagens.';
    }).finally(() => {
      this.salvandoAssinaturaWhatsapp = false;
    });
  }

  private notifiqueExtensaoAssinarMensagens() {
    if (!this.usuario || !this.usuario.nome) {
      return;
    }

    window.parent.postMessage({
      tipo: 'NOVA_MENSAGEM', text: {
        tipo: 'SALVAR_ASSINATURA',
        assinatura: this.usuario.assinarMensagens ? this.usuario.nome : ''
      }
    }, '*');
  }

  private prepareModoSuporteIndividualSeAtivo(): void {
    if( this.modoSuporte ) {
      this.prepareModoSuporteIndividual();
    }
  }

  private prepareModoSuporteIndividual(): void {
    this.widget = this.inIframe();
    this.nomeContato = this.normalizeNomeSuporte(this.activatedRoute.snapshot.queryParams.nome);
    this.telefone = decodeURIComponent(this.activatedRoute.snapshot.params['zap'] || '');
    this.contato = null;
    this.cartoes = [];
    this.contatoPorDados = {};
    this.carregou = true;
    this.carregueContextoContatoSuporte();
  }

  carregueContextoContatoSuporte() {
    if (!this.modoSuporte || !this.telefone) {
      return;
    }

    const chatId = this.activatedRoute.snapshot.queryParams.chatId || '';
    const chaveContexto = `${this.telefone}|${chatId}|${this.nomeContato || ''}`;

    if (this.chaveContextoContatoSuporte === chaveContexto &&
        (this.suporteContatoCarregando || this.suporteContatoContexto)) {
      return;
    }

    const numeroContexto = ++this.numeroContextoContatoSuporte;
    this.chaveContextoContatoSuporte = chaveContexto;
    this.suporteContatoCarregando = true;
    this.suporteContatoErro = '';
    this.suporteContatoContexto = null;
    this.suporteContatoEmpresaSelecionada = null;
    this.suporteContatoEmpresas = [];
    this.suporteContatoUsuariosEmpresa = [];
    this.suporteContatoTermoEmpresa = '';
    this.suporteContatoBuscouEmpresas = false;
    this.suporteContatoEditando = false;
    this.suporteContatoDesvinculando = false;
    this.suporteContatoExibindoDesvincular = false;
    this.suporteContatoJustificativaDesvinculo = '';
    this.numeroBuscaContatoSuporte++;
    clearTimeout(this.timeoutBuscaEmpresasSuporte);

    this.suporteContatosWhatsappService.obtenhaContexto(this.telefone, chatId, this.nomeContato).then(contexto => {
      if (numeroContexto !== this.numeroContextoContatoSuporte) {
        return;
      }

      this.apliqueContextoContatoSuporte(contexto);
    }).catch(erro => {
      if (numeroContexto !== this.numeroContextoContatoSuporte) {
        return;
      }

      this.suporteContatoErro = erro || 'Não foi possível carregar o contato.';
    }).finally(() => {
      if (numeroContexto !== this.numeroContextoContatoSuporte) {
        return;
      }

      this.suporteContatoCarregando = false;
    });
  }

  busqueEmpresasContatoSuporte() {
    clearTimeout(this.timeoutBuscaEmpresasSuporte);
    const numeroBusca = ++this.numeroBuscaContatoSuporte;

    this.suporteContatoBuscandoEmpresas = true;
    this.suporteContatoBuscouEmpresas = true;
    this.suporteContatoErro = '';
    this.suporteContatoEmpresas = [];

    this.suporteWhatsappService.listeEmpresas(this.suporteContatoTermoEmpresa).then(empresas => {
      if (numeroBusca !== this.numeroBuscaContatoSuporte) {
        return;
      }

      this.suporteContatoEmpresas = empresas || [];
    }).catch(erro => {
      if (numeroBusca !== this.numeroBuscaContatoSuporte) {
        return;
      }

      this.suporteContatoErro = erro || 'Não foi possível buscar empresas.';
    }).finally(() => {
      if (numeroBusca !== this.numeroBuscaContatoSuporte) {
        return;
      }

      this.suporteContatoBuscandoEmpresas = false;
    });
  }

  agendeBuscaEmpresasContatoSuporte() {
    clearTimeout(this.timeoutBuscaEmpresasSuporte);

    this.timeoutBuscaEmpresasSuporte = setTimeout(() => {
      this.busqueEmpresasContatoSuporte();
    }, 350);
  }

  selecioneEmpresaContatoSuporte(empresa: any) {
    this.suporteContatoEmpresaSelecionada = empresa;
    this.suporteContatoForm.usuarioEmpresaId = null;
    this.carregueUsuariosEmpresaContatoSuporte(empresa && empresa.id);
  }

  editeVinculoContatoSuporte() {
    this.suporteContatoEditando = true;
    this.suporteContatoEmpresaSelecionada = this.suporteContatoContexto && this.suporteContatoContexto.empresaSuporte;
    this.suporteContatoTermoEmpresa = this.suporteContatoEmpresaSelecionada ? this.suporteContatoEmpresaSelecionada.nome : '';
    this.carregueUsuariosEmpresaContatoSuporte(this.suporteContatoEmpresaSelecionada && this.suporteContatoEmpresaSelecionada.id);
  }

  canceleEdicaoContatoSuporte() {
    this.suporteContatoEditando = false;
    this.apliqueContextoContatoSuporte(this.suporteContatoContexto);
  }

  vinculeContatoSuporte() {
    if (!this.suporteContatoEmpresaSelecionada) {
      this.suporteContatoErro = 'Selecione a empresa atendida.';
      return;
    }

    this.suporteContatoSalvando = true;
    this.suporteContatoErro = '';

    this.suporteContatosWhatsappService.vinculeContato({
      telefone: this.telefone,
      chatId: this.activatedRoute.snapshot.queryParams.chatId || '',
      nome: this.nomeContato,
      empresaSuporteId: this.suporteContatoEmpresaSelecionada.id,
      funcao: this.suporteContatoForm.funcao,
      usuarioEmpresaId: this.suporteContatoForm.usuarioEmpresaId
    }).then(contexto => {
      this.apliqueContextoContatoSuporte(contexto);
      this.suporteContatoEditando = false;
      this.suporteContatoExibindoDesvincular = false;
      this.suporteContatoJustificativaDesvinculo = '';
    }).catch(erro => {
      this.suporteContatoErro = erro || 'Não foi possível vincular o contato.';
    }).finally(() => {
      this.suporteContatoSalvando = false;
    });
  }

  abraDesvincularContatoSuporte() {
    this.suporteContatoExibindoDesvincular = true;
    this.suporteContatoJustificativaDesvinculo = '';
    this.suporteContatoErro = '';
  }

  canceleDesvincularContatoSuporte() {
    this.suporteContatoExibindoDesvincular = false;
    this.suporteContatoJustificativaDesvinculo = '';
  }

  desvinculeContatoSuporte() {
    if (!this.suporteContatoJustificativaDesvinculo || !String(this.suporteContatoJustificativaDesvinculo).trim()) {
      this.suporteContatoErro = 'Informe a justificativa para desvincular o contato.';
      return;
    }

    this.suporteContatoDesvinculando = true;
    this.suporteContatoErro = '';

    this.suporteContatosWhatsappService.desvinculeContato({
      telefone: this.telefone,
      chatId: this.activatedRoute.snapshot.queryParams.chatId || '',
      nome: this.nomeContato,
      justificativa: this.suporteContatoJustificativaDesvinculo
    }).then(contexto => {
      this.apliqueContextoContatoSuporte(contexto);
      this.suporteContatoExibindoDesvincular = false;
      this.suporteContatoJustificativaDesvinculo = '';
    }).catch(erro => {
      this.suporteContatoErro = erro || 'Não foi possível desvincular o contato.';
    }).finally(() => {
      this.suporteContatoDesvinculando = false;
    });
  }

  abraGrupoEmpresaAtendida() {
    const grupo = this.suporteContatoContexto && this.suporteContatoContexto.grupoSuporte;

    if (!grupo || !grupo.whatsappChatId) {
      this.suporteContatoErro = 'Esta empresa ainda não tem grupo vinculado.';
      return;
    }

    this.whatsappService.abraConversa(grupo.whatsappChatId);
  }

  textoFuncaoContatoSuporte(funcao: string): string {
    const mapa: any = {
      PROPRIETARIO: 'Proprietário',
      EQUIPE: 'Membro da equipe',
      MARKETING: 'Marketing',
      OUTRO: 'Outro'
    };

    return mapa[funcao] || 'Outro';
  }

  textoAcaoHistoricoContatoSuporte(acao: string): string {
    const mapa: any = {
      VINCULAR: 'Vinculou',
      DESVINCULAR: 'Desvinculou'
    };

    return mapa[acao] || acao;
  }

  private carregueUsuariosEmpresaContatoSuporte(empresaId: number) {
    if (!empresaId) {
      this.suporteContatoUsuariosEmpresa = [];
      return;
    }

    this.suporteContatosWhatsappService.listeUsuariosEmpresa(empresaId).then(usuarios => {
      this.suporteContatoUsuariosEmpresa = usuarios || [];
    }).catch(() => {
      this.suporteContatoUsuariosEmpresa = [];
    });
  }

  private apliqueContextoContatoSuporte(contexto: any) {
    this.suporteContatoContexto = contexto;
    this.suporteContatoEmpresaSelecionada = contexto && contexto.empresaSuporte;
    this.suporteContatoForm = {
      funcao: (contexto && contexto.contato && contexto.contato.funcao) || 'OUTRO',
      usuarioEmpresaId: (contexto && contexto.contato && contexto.contato.usuarioEmpresaId) || null
    };

    if (contexto && contexto.empresaSuporte) {
      this.carregueUsuariosEmpresaContatoSuporte(contexto.empresaSuporte.id);
    }
  }

  private normalizeNomeSuporte(valor: any): string {
    if (!valor || valor === 'undefined') {
      return '';
    }

    return String(valor);
  }

  async imprimaPedido(pedido: any) {
    if(this.empresa?.configImpressao?.imprimirTXT && this.impressorasConfiguradas.length === 1) {
      const impressoraPadrao = this.obtenhaImpressoraPadrao();

      if(impressoraPadrao) {
        const impressora = {...impressoraPadrao};
        const layout = this.obtenhaLayoutPadrao(impressora);

        if(layout)
          impressora.layout = layout;

        await this.impressaoService.imprimaQzTray(pedido, impressora);
        return;
      }
    }

    window.open('/imprimir/pedido/' + pedido.guid);
  }

  digitouMensagemBot($event: any) {
    const mensagem = $event.target.value;

    window['root'].novasMensagens([mensagem]);

    $event.target.value = '';
  }

  alterouStatusBot() {

  }

  executarDiagnostico() {
    if (!this.contato) {
      this.exibirRelatorio('🩺 Diagnóstico', 'Nenhum contato carregado para diagnóstico.');
      return;
    }

    const titulo = '🩺 Diagnóstico do Contato';
    const telefoneCompleto = (this.contato.codigoPais || '') + this.contato.telefone;
    let logs = this.diagnosticoWhatsappService.obterLogsPorTelefone(telefoneCompleto);

    // Se não encontrou logs, testar variações do telefone (com/sem 9 extra)
    if (logs.length === 0) {
      const variacoesTelefone = this.gerarVariacoesTelefone(telefoneCompleto);

      for (const variacao of variacoesTelefone) {
        logs = this.diagnosticoWhatsappService.obterLogsPorTelefone(variacao);
        if (logs.length > 0) {
          console.log(`[Debug] Logs de diagnóstico encontrados com variação: ${variacao} (original: ${telefoneCompleto})`);
          break;
        }
      }
    }

    if (logs.length === 0) {
      this.exibirRelatorio(titulo, `Nenhum log encontrado para o telefone ${telefoneCompleto} (testadas variações com/sem 9 extra)`);
      return;
    }

    this.exibirRelatorioListView(titulo, logs);
  }

  private coletarInformacoesDiagnostico(): any {
    const diagnostico: any = {
      timestamp: new Date().toLocaleString('pt-BR'),
      contato: {},
      whatsapp: {},
      mia: {},
      sistema: {},
      logsWhatsapp: {}
    };

    // Informações do contato
    if (this.contato) {
      diagnostico.contato = {
        id: this.contato.id || 'Não definido',
        nome: this.contato.nome || 'Não informado',
        telefone: this.contato.telefone || 'Não informado',
        codigoPais: this.contato.codigoPais || 'Não informado',
        telefoneCompleto: (this.contato.codigoPais || '') + (this.contato.telefone || ''),
        status: this.contato.status || 'Não definido',
        email: this.contato.email || 'Não informado',
        bloqueado: this.contato.bloqueado ? 'Sim' : 'Não',
        dataAtivacao: this.contato.dataAtivacao || 'Não definido',
        ultimaVisita: this.contato.ultimaVisita || 'Não definido',
        quantidadeCartoes: this.contato.cartoes ? this.contato.cartoes.length : 0,
        tags: this.contato.tags ? this.contato.tags.map((tag: any) => tag.nome).join(', ') : 'Nenhuma'
      };
    }

    // Informações do WhatsApp/Mia
    diagnostico.mia = {
      statusMia: this.statusMia ? 'Ativa' : 'Inativa',
      atendente: this.atendente ? 'Sim' : 'Não',
      desativarParaSempre: this.desativarParaSempre ? 'Sim' : 'Não'
    };

    // Informações do sistema
    diagnostico.sistema = {
      carregou: this.carregou ? 'Sim' : 'Não',
      widget: this.widget ? 'Sim' : 'Não',
      dev: this.dev ? 'Sim' : 'Não',
      empresaId: this.empresa?.id || 'Não definido',
      empresaNome: this.empresa?.nome || 'Não definido',
      usuarioId: this.usuario?.id || 'Não definido',
      usuarioNome: this.usuario?.nome || 'Não definido'
    };

    // Informações do WhatsApp (se disponível)
    diagnostico.whatsapp = {
      numeroWhatsapp: (window as any)['numeroWhatsapp'] || 'Não disponível',
      carregouWhatsapp: (window as any)['carregouWhatsapp'] || false,
      inIframe: this.inIframe() ? 'Sim' : 'Não'
    };

    // Logs específicos do WhatsApp para este contato
    if (this.contato?.telefone) {
      const telefoneCompleto = (this.contato.codigoPais || '') + this.contato.telefone;
      let logsContato = this.diagnosticoWhatsappService.obterLogsPorTelefone(telefoneCompleto);
      let estatisticas = this.diagnosticoWhatsappService.obterEstatisticas(telefoneCompleto);

      // Se não encontrou logs, testar variações do telefone (com/sem 9 extra)
      if (logsContato.length === 0) {
        const variacoesTelefone = this.gerarVariacoesTelefone(telefoneCompleto);

        for (const variacao of variacoesTelefone) {
          logsContato = this.diagnosticoWhatsappService.obterLogsPorTelefone(variacao);
          if (logsContato.length > 0) {
            estatisticas = this.diagnosticoWhatsappService.obterEstatisticas(variacao);
            console.log(`[Debug] Logs para diagnóstico completo encontrados com variação: ${variacao} (original: ${telefoneCompleto})`);
            break;
          }
        }
      }

      diagnostico.logsWhatsapp = {
        totalLogs: logsContato.length,
        ultimoLog: logsContato[0]?.timestamp || 'Nenhum',
        estatisticas: estatisticas,
        logsRecentes: logsContato.slice(0, 5).map(log => ({
          timestamp: log.timestamp.toLocaleTimeString('pt-BR'),
          tipo: log.tipo,
          categoria: log.categoria,
          mensagem: log.mensagem
        }))
      };
    } else {
      diagnostico.logsWhatsapp = {
        totalLogs: 0,
        ultimoLog: 'N/A - Contato sem telefone',
        estatisticas: null,
        logsRecentes: []
      };
    }

    return diagnostico;
  }



  private obterEmojiPorTipo(tipo: string): string {
    const emojis: any = {
      'INFO': 'ℹ️',
      'WARNING': '⚠️',
      'ERROR': '❌',
      'SUCCESS': '✅'
    };
    return emojis[tipo] || 'ℹ️';
  }



  /**
   * Método para exibir logs detalhados do WhatsApp
   */
  exibirLogsDetalhados(): void {
    if (!this.contato?.telefone) {
      this.exibirTodosLogs();
      return;
    }

    const telefoneCompleto = (this.contato.codigoPais || '') + this.contato.telefone;
    let logs = this.diagnosticoWhatsappService.obterLogsPorTelefone(telefoneCompleto);

    // Se não encontrou logs, testar variações do telefone (com/sem 9 extra)
    if (logs.length === 0) {
      const variacoesTelefone = this.gerarVariacoesTelefone(telefoneCompleto);

      for (const variacao of variacoesTelefone) {
        logs = this.diagnosticoWhatsappService.obterLogsPorTelefone(variacao);
        if (logs.length > 0) {
          console.log(`[Debug] Logs detalhados encontrados com variação: ${variacao} (original: ${telefoneCompleto})`);
          break;
        }
      }
    }

    if (logs.length === 0) {
      // Se ainda não há logs para este contato, mostrar todos os logs
      this.exibirTodosLogs();
      return;
    }

    const titulo = `🔍 Logs Detalhados - ${this.contato.nome || 'Contato'}`;
    this.exibirRelatorioListView(titulo, logs);
  }

  /**
   * Método para exibir logs filtrados do contato atual
   */
  exibirTodosLogs(): void {
    // Se não há contato carregado, mostrar todos os logs do sistema
    if (!this.contato?.telefone) {
      const titulo = '🔍 Todos os Logs do Sistema (Debug)';
      const logs = this.diagnosticoWhatsappService.obterTodosLogs();
      this.exibirRelatorioListView(titulo, logs);
      return;
    }

    // Filtrar logs do contato atual, testando variações do telefone com/sem 9 extra
    const telefoneCompleto = (this.contato.codigoPais || '') + this.contato.telefone;
    let logs = this.diagnosticoWhatsappService.obterLogsPorTelefone(telefoneCompleto);

    // Se não encontrou logs, testar variações do telefone (com/sem 9 extra)
    if (logs.length === 0) {
      const variacoesTelefone = this.gerarVariacoesTelefone(telefoneCompleto);

      for (const variacao of variacoesTelefone) {
        logs = this.diagnosticoWhatsappService.obterLogsPorTelefone(variacao);
        if (logs.length > 0) {
          console.log(`[Debug] Logs encontrados com variação: ${variacao} (original: ${telefoneCompleto})`);
          break;
        }
      }
    }

    const nomeContato = this.contato.nome || 'Contato';
    const titulo = `🔍 Logs do Contato: ${nomeContato} (${telefoneCompleto})`;

    this.exibirRelatorioListView(titulo, logs);
  }

  /**
   * Gera variações do telefone para busca (com/sem 9 extra)
   */
  private gerarVariacoesTelefone(telefoneCompleto: string): string[] {
    const variacoes: string[] = [];

    // Regex para telefones brasileiros: +55 + DDD (2 dígitos) + número
    const regexBrasil = /^(\+55)(\d{2})(\d{8,9})$/;
    const match = telefoneCompleto.match(regexBrasil);

    if (match) {
      const [, codigoPais, ddd, numero] = match;

      if (numero.length === 9 && numero.startsWith('9')) {
        // Telefone tem 9 dígitos e começa com 9 - remover o 9 extra
        const numeroSem9 = numero.substring(1);
        variacoes.push(`${codigoPais}${ddd}${numeroSem9}`);
      } else if (numero.length === 8) {
        // Telefone tem 8 dígitos - adicionar o 9 extra
        const numeroCom9 = '9' + numero;
        variacoes.push(`${codigoPais}${ddd}${numeroCom9}`);
      }
    }

    return variacoes;
  }

  /**
   * Método genérico para exibir relatório na tela
   */
  exibirRelatorio(titulo: string, conteudo: string): void {
    this.tituloRelatorio = titulo;
    this.conteudoRelatorio = conteudo;
    this.conteudoRelatorioFormatado = this.formatarRelatorioHTML(conteudo);
    this.dataGeracaoRelatorio = new Date().toLocaleString('pt-BR');
    this.exibirRelatorioNaTela = true;

    // Scroll para o relatório
    setTimeout(() => {
      const elemento = document.querySelector('.card.mt-3');
      if (elemento) {
        elemento.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  /**
   * Novo método para exibir relatório em ListView
   */
  exibirRelatorioListView(titulo: string, logs: any[]): void {
    this.tituloRelatorio = titulo;
    this.dataGeracaoRelatorio = new Date().toLocaleString('pt-BR');

    // Converter logs do serviço para o formato do ListView
    this.logsListView = this.converterLogsParaListView(logs);
    this.logsListViewFiltrados = [...this.logsListView];
    this.totalLogs = this.logsListView.length;

    // Calcular estatísticas
    this.calcularEstatisticas();

    this.exibirRelatorioNaTela = true;

    // Scroll para o relatório
    setTimeout(() => {
      const elemento = document.querySelector('.card.mt-3');
      if (elemento) {
        elemento.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  /**
   * Método para fechar relatório
   */
  fecharRelatorio(): void {
    this.exibirRelatorioNaTela = false;
    this.conteudoRelatorio = '';
    this.conteudoRelatorioFormatado = '';
    this.tituloRelatorio = '';
    this.dataGeracaoRelatorio = '';

    // Limpar dados do ListView
    this.logsListView = [];
    this.logsListViewFiltrados = [];
    this.filtroTipo = 'TODOS';
    this.filtroCategoria = 'TODAS';
    this.textoBusca = '';
    this.totalLogs = 0;
    this.estatisticas = {
      sucessos: 0,
      erros: 0,
      avisos: 0,
      processamentos: 0
    };
  }

  /**
   * Formata o relatório em HTML com cores e estilos
   */
  private formatarRelatorioHTML(conteudo: string): string {
    // Primeiro, escapa caracteres HTML especiais
    let html = conteudo
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    // Processa linhas individualmente para melhor controle
    const linhas = html.split('\n');
    const linhasProcessadas = linhas.map(linha => {
      let linhaProcessada = linha;

      // Detecta e formata diferentes tipos de logs com base no ícone de status
      if (linha.includes('✅')) {
        linhaProcessada = `<div class="log-success">${linha}</div>`;
      } else if (linha.includes('❌')) {
        linhaProcessada = `<div class="log-error">${linha}</div>`;
      } else if (linha.includes('⚠️')) {
        linhaProcessada = `<div class="log-warning">${linha}</div>`;
      } else if (linha.includes('🔄')) {
        linhaProcessada = `<div class="log-processing">${linha}</div>`;
      } else if (linha.includes('🔵')) {
        linhaProcessada = `<div class="log-info">${linha}</div>`;
      }
      // Headers e títulos
      else if (linha.includes('📈 RESUMO:')) {
        linhaProcessada = `<div class="log-header">${linha}</div>`;
      } else if (linha.includes('🔍 LOGS WHATSAPP')) {
        linhaProcessada = `<div class="log-title">${linha}</div>`;
      }
      // Separadores
      else if (/^═+$/.test(linha.trim())) {
        linhaProcessada = `<div class="log-separator">${linha}</div>`;
      } else if (/^─+$/.test(linha.trim())) {
        linhaProcessada = `<div class="log-divider">${linha}</div>`;
      } else if (/^┄+$/.test(linha.trim())) {
        linhaProcessada = `<div class="log-subdivider">${linha}</div>`;
      }
      // Linhas com informações específicas
      else if (linha.includes('⏰')) {
        linhaProcessada = `<span class="log-time">${linha}</span>`;
      } else if (linha.includes('👤')) {
        linhaProcessada = `<span class="log-user">${linha}</span>`;
      } else if (linha.includes('💬')) {
        linhaProcessada = `<span class="log-message">${linha}</span>`;
      } else if (linha.includes('📝')) {
        // Texto da mensagem - adiciona formatação especial
        linhaProcessada = `<span class="log-text-message">${linha}</span>`;
      } else if (linha.includes('📱')) {
        linhaProcessada = `<span class="log-phone">${linha}</span>`;
      } else if (linha.includes('⏱️')) {
        linhaProcessada = `<span class="log-duration">${linha}</span>`;
      } else if (linha.includes('🤖')) {
        linhaProcessada = `<span class="log-info">${linha}</span>`;
      } else if (linha.includes('🆔')) {
        linhaProcessada = `<span class="log-info">${linha}</span>`;
      } else if (linha.includes('📅')) {
        linhaProcessada = `<span class="log-info">${linha}</span>`;
      }

      return linhaProcessada;
    });

    // Junta as linhas processadas com <br> para manter quebras de linha
    const htmlFinal = linhasProcessadas.join('<br>');

    return `<div class="log-formatted">${htmlFinal}</div>`;
  }

  /**
   * Método para copiar relatório para área de transferência
   */
  copiarRelatorio(): void {
    let textoParaCopiar = '';

    if (this.logsListView.length > 0) {
      // Gerar texto a partir do ListView
      textoParaCopiar = this.gerarTextoDoListView();
    } else {
      // Usar conteúdo original como fallback
      textoParaCopiar = this.conteudoRelatorio;
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textoParaCopiar).then(() => {
        console.log('Relatório copiado para área de transferência');
        // Aqui você pode adicionar uma notificação de sucesso se quiser
      }).catch(err => {
        console.error('Erro ao copiar relatório:', err);
        this.copiarRelatorioFallback(textoParaCopiar);
      });
    } else {
      this.copiarRelatorioFallback(textoParaCopiar);
    }
  }

  /**
   * Gera texto formatado a partir dos logs do ListView
   */
  private gerarTextoDoListView(): string {
    let texto = `🔍 ${this.tituloRelatorio}\n`;
    texto += `📅 Gerado em: ${this.dataGeracaoRelatorio}\n`;
    texto += `📊 Total: ${this.totalLogs} logs\n`;
    texto += `${'═'.repeat(65)}\n\n`;

    // Estatísticas
    if (this.estatisticas.sucessos > 0) texto += `✅ ${this.estatisticas.sucessos} sucessos  `;
    if (this.estatisticas.erros > 0) texto += `❌ ${this.estatisticas.erros} erros  `;
    if (this.estatisticas.avisos > 0) texto += `⚠️ ${this.estatisticas.avisos} avisos  `;
    if (this.estatisticas.processamentos > 0) texto += `🔄 ${this.estatisticas.processamentos} processamentos`;
    texto += '\n\n';

    // Logs filtrados
    const logsParaExportar = this.logsListViewFiltrados.length > 0 ? this.logsListViewFiltrados : this.logsListView;

    logsParaExportar.forEach((log, index) => {
      texto += `${log.icone} ${log.iconeCategoria} ${log.categoria}\n`;
      texto += `⏰ ${log.timestamp.toLocaleTimeString('pt-BR')} (${log.tempoRelativo}) | 👤 ${log.nome}\n`;
      texto += `💬 ${log.mensagem}\n`;

      if (log.textoMensagem) {
        texto += `📝 Texto: "${log.textoMensagem}"\n`;
      }

      if (log.detalhesFormatados) {
        texto += `${log.detalhesFormatados}\n`;
      }

      if (index < logsParaExportar.length - 1) {
        texto += `${'─'.repeat(40)}\n\n`;
      }
    });

    return texto;
  }

  /**
   * Método fallback para copiar texto (navegadores mais antigos)
   */
  private copiarRelatorioFallback(texto?: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = texto || this.conteudoRelatorio;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      console.log('Relatório copiado para área de transferência (fallback)');
    } catch (err) {
      console.error('Erro ao copiar relatório (fallback):', err);
    }

    document.body.removeChild(textArea);
  }

  /**
   * Método específico para exibir resultado do diagnóstico na tela
   */
  exibirResultadoDiagnosticoNaTela(diagnostico: any): void {
    let mensagem = `🔍 DIAGNÓSTICO COMPLETO\n`;
    mensagem += `📅 ${diagnostico.timestamp}\n\n`;

    mensagem += `👤 CONTATO:\n`;
    mensagem += `• Nome: ${diagnostico.contato.nome}\n`;
    mensagem += `• Telefone: ${diagnostico.contato.telefone}\n`;
    mensagem += `• Último contato: ${diagnostico.contato.ultimoContato}\n\n`;

    mensagem += `🤖 MIA:\n`;
    mensagem += `• Status: ${diagnostico.mia.status}\n`;
    mensagem += `• Ativa: ${diagnostico.mia.ativa}\n`;
    mensagem += `• Modo teste: ${diagnostico.mia.modoTeste}\n\n`;

    mensagem += `📱 WHATSAPP:\n`;
    mensagem += `• Número: ${diagnostico.whatsapp.numeroWhatsapp}\n`;
    mensagem += `• Carregou: ${diagnostico.whatsapp.carregouWhatsapp}\n`;
    mensagem += `• Em iframe: ${diagnostico.whatsapp.inIframe}\n\n`;

    mensagem += `⚙️ SISTEMA:\n`;
    mensagem += `• Componente carregado: ${diagnostico.sistema.carregou}\n`;
    mensagem += `• Modo widget: ${diagnostico.sistema.widget}\n`;
    mensagem += `• Modo desenvolvimento: ${diagnostico.sistema.dev}\n`;
    mensagem += `• Empresa: ${diagnostico.sistema.empresaNome} (ID: ${diagnostico.sistema.empresaId})\n`;
    mensagem += `• Usuário: ${diagnostico.sistema.usuarioNome} (ID: ${diagnostico.sistema.usuarioId})\n\n`;

    mensagem += `📋 LOGS WHATSAPP:\n`;
    mensagem += `• Total de logs: ${diagnostico.logsWhatsapp.totalLogs}\n`;
    mensagem += `• Último log: ${diagnostico.logsWhatsapp.ultimoLog}\n`;

    if (diagnostico.logsWhatsapp.estatisticas) {
      const stats = diagnostico.logsWhatsapp.estatisticas;
      mensagem += `• Sucessos: ${stats.porTipo.SUCCESS || 0}\n`;
      mensagem += `• Avisos: ${stats.porTipo.WARNING || 0}\n`;
      mensagem += `• Erros: ${stats.porTipo.ERROR || 0}\n`;
    }

    if (diagnostico.logsWhatsapp.logsRecentes.length > 0) {
      mensagem += `\n📝 LOGS RECENTES:\n`;
      diagnostico.logsWhatsapp.logsRecentes.forEach((log: any) => {
        const emoji = this.obterEmojiPorTipo(log.tipo);
        mensagem += `${emoji} [${log.timestamp}] ${log.mensagem}\n`;
      });
    }

    this.exibirRelatorio('🩺 Diagnóstico do Contato', mensagem);

    // Log no console para debug técnico
    console.log('🔍 Diagnóstico completo:', diagnostico);
  }

  ngOnDestroy(): void {
    if( this.assinante ) {
      this.assinante.unsubscribe();
    }

    this.assinantesRotaSuporte.forEach(assinante => assinante.unsubscribe());
    clearTimeout(this.timeoutBuscaEmpresasSuporte);
  }

  /**
   * Converte logs do serviço para o formato do ListView
   */
  private converterLogsParaListView(logs: any[]): LogItem[] {
    return logs.map(log => {
      const icone = this.obterIconeStatus(log);
      const iconeCategoria = this.obterIconeCategoriaVisual(log.categoria);
      const cssClass = this.obterCssClass(log);
      const tempoRelativo = this.obterTempoRelativo(log.timestamp);
      const detalhesFormatados = this.formatarDetalhesParaListView(log.detalhes);

      return {
        timestamp: log.timestamp,
        tempoRelativo: tempoRelativo,
        tipo: log.tipo,
        categoria: log.categoria,
        icone: icone,
        iconeCategoria: iconeCategoria,
        nome: log.nome || 'Sistema',
        telefone: log.telefone || '',
        mensagem: log.mensagem,
        textoMensagem: log.textoMensagem,
        tipoMensagem: log.tipoMensagem,
        detalhes: log.detalhes,
        detalhesFormatados: detalhesFormatados,
        cssClass: cssClass,
        expanded: false
      };
    });
  }

  /**
   * Obtém ícone de status baseado no tipo e contexto do log
   */
  private obterIconeStatus(log: any): string {
    const mensagem = log.mensagem.toLowerCase();

    if (log.tipo === 'SUCCESS' || mensagem.includes('enviada com sucesso') || mensagem.includes('sucesso')) {
      return '✅';
    }

    if (log.tipo === 'ERROR' || mensagem.includes('erro') || mensagem.includes('falhou')) {
      return '❌';
    }

    if (log.tipo === 'WARNING' || mensagem.includes('bloqueada') || mensagem.includes('insuficiente') ||
        mensagem.includes('não vai enviar') || mensagem.includes('validação falhou')) {
      return '⚠️';
    }

    if (mensagem.includes('processando') || mensagem.includes('verificando') || mensagem.includes('iniciando')) {
      return '🔄';
    }

    return '🔵';
  }

  /**
   * Obtém ícone da categoria
   */
  private obterIconeCategoriaVisual(categoria: string): string {
    const icones = {
      'ENVIO': '📤',
      'VALIDACAO': '🔍',
      'PROCESSAMENTO': '⚙️',
      'SISTEMA': '🖥️'
    };
    return icones[categoria] || '📋';
  }

  /**
   * Obtém classe CSS baseada no tipo de log
   */
  private obterCssClass(log: any): string {
    const icone = this.obterIconeStatus(log);

    switch (icone) {
      case '✅': return 'log-success';
      case '❌': return 'log-error';
      case '⚠️': return 'log-warning';
      case '🔄': return 'log-processing';
      default: return 'log-info';
    }
  }

  /**
   * Calcula tempo relativo
   */
  private obterTempoRelativo(timestamp: Date): string {
    const agora = new Date();
    const diffMs = agora.getTime() - timestamp.getTime();
    const diffMinutos = Math.floor(diffMs / 60000);

    if (diffMinutos < 1) return 'agora';
    if (diffMinutos < 60) return `há ${diffMinutos}min`;

    const diffHoras = Math.floor(diffMinutos / 60);
    if (diffHoras < 24) return `há ${diffHoras}h`;

    const diffDias = Math.floor(diffHoras / 24);
    return `há ${diffDias}d`;
  }

  /**
   * Formata detalhes para exibição no ListView
   */
  private formatarDetalhesParaListView(detalhes: any): string {
    if (!detalhes || typeof detalhes !== 'object' || Object.keys(detalhes).length === 0) {
      return '';
    }

    let resultado = '';

    if (detalhes.tempoDecorrido !== undefined && detalhes.tempoNecessario !== undefined) {
      resultado += `⏱️ Tempo: ${detalhes.tempoDecorrido.toFixed(1)}h / ${detalhes.tempoNecessario.toFixed(1)}h necessárias\n`;
    }

    if (detalhes.statusMia) {
      resultado += `🤖 Mia: ${detalhes.statusMia}\n`;
    }

    if (detalhes.mensagemId) {
      resultado += `🆔 ID: ${detalhes.mensagemId}\n`;
    }

    if (detalhes.horarioEnvio) {
      resultado += `📅 Enviado: ${detalhes.horarioEnvio}\n`;
    }

    return resultado.trim();
  }

  /**
   * Calcula estatísticas dos logs
   */
  private calcularEstatisticas(): void {
    this.estatisticas = {
      sucessos: 0,
      erros: 0,
      avisos: 0,
      processamentos: 0
    };

    this.logsListView.forEach(log => {
      switch (log.icone) {
        case '✅':
          this.estatisticas.sucessos++;
          break;
        case '❌':
          this.estatisticas.erros++;
          break;
        case '⚠️':
          this.estatisticas.avisos++;
          break;
        case '🔄':
          this.estatisticas.processamentos++;
          break;
      }
    });
  }

  /**
   * Filtrar logs
   */
  filtrarLogs(): void {
    let logsFiltrados = [...this.logsListView];

    // Filtrar por tipo
    if (this.filtroTipo !== 'TODOS') {
      logsFiltrados = logsFiltrados.filter(log => log.tipo === this.filtroTipo);
    }

    // Filtrar por categoria
    if (this.filtroCategoria !== 'TODAS') {
      logsFiltrados = logsFiltrados.filter(log => log.categoria === this.filtroCategoria);
    }

    // Filtrar por texto de busca
    if (this.textoBusca && this.textoBusca.trim()) {
      const textoBuscaLower = this.textoBusca.toLowerCase();
      logsFiltrados = logsFiltrados.filter(log =>
        log.mensagem.toLowerCase().includes(textoBuscaLower) ||
        (log.textoMensagem && log.textoMensagem.toLowerCase().includes(textoBuscaLower)) ||
        log.nome.toLowerCase().includes(textoBuscaLower) ||
        log.telefone.includes(textoBuscaLower)
      );
    }

    this.logsListViewFiltrados = logsFiltrados;
  }

  /**
   * Expandir/colapsar detalhes do log
   */
  toggleDetalhes(item: LogItem): void {
    item.expanded = !item.expanded;
  }

  /**
   * Limpar filtros
   */
  limparFiltros(): void {
    this.filtroTipo = 'TODOS';
    this.filtroCategoria = 'TODAS';
    this.textoBusca = '';
    this.logsListViewFiltrados = [...this.logsListView];
  }

  /**
   * Método para limpar todos os logs
   */
  limparLogs(): void {
    // Confirmar antes de limpar
    if (!confirm('Tem certeza que deseja limpar todos os logs? Esta ação não pode ser desfeita.')) {
      return;
    }

    try {
      // Limpar logs do serviço (localStorage)
      this.diagnosticoWhatsappService.limparTodosLogsCompleto();

      // Limpar variáveis locais do componente
      this.logsListView = [];
      this.logsListViewFiltrados = [];
      this.conteudoRelatorio = '';
      this.conteudoRelatorioFormatado = '';
      this.totalLogs = 0;
      this.estatisticas = {
        sucessos: 0,
        erros: 0,
        avisos: 0,
        processamentos: 0
      };

      // Limpar filtros também
      this.filtroTipo = 'TODOS';
      this.filtroCategoria = 'TODAS';
      this.textoBusca = '';

      // Verificar se realmente foi limpo
      const logsRestantes = this.diagnosticoWhatsappService.obterTodosLogs();

      // Debug: verificar localStorage diretamente
      const storageKey = 'diagnostico_whatsapp_logs';
      const itemLocalStorage = localStorage.getItem(storageKey);

      console.log('[VerContatoIframe] Debug pós-limpeza:');
      console.log('- Logs no serviço:', logsRestantes.length);
      console.log('- Item no localStorage:', itemLocalStorage);

      if (logsRestantes.length === 0 && !itemLocalStorage) {
        alert('✅ Todos os logs foram limpos com sucesso!');
        console.log('[VerContatoIframe] Todos os logs foram limpos permanentemente');
      } else {
        console.warn('[VerContatoIframe] Ainda existem logs após limpeza:', logsRestantes.length);
        console.warn('[VerContatoIframe] localStorage ainda contém:', itemLocalStorage);
        alert('⚠️ Houve um problema na limpeza. Alguns logs podem ainda estar presentes.');
      }
    } catch (error) {
      console.error('[VerContatoIframe] Erro ao limpar logs:', error);
      alert('❌ Erro ao limpar logs. Verifique o console para mais detalhes.');
    }
  }

  /**
   * Método de debug para verificar estado dos logs
   */
  debugEstadoLogs(): void {
    const logs = this.diagnosticoWhatsappService.obterTodosLogs();
    const storageKey = 'diagnostico_whatsapp_logs';
    const itemLocalStorage = localStorage.getItem(storageKey);
    const info = this.diagnosticoWhatsappService.obterInfoArmazenamento();

    console.log('🔍 DEBUG - Estado atual dos logs:');
    console.log('- Logs no serviço:', logs.length);
    console.log('- Logs no componente:', this.logsListView.length);
    console.log('- Item no localStorage:', itemLocalStorage ? 'Existe' : 'Não existe');
    console.log('- Tamanho localStorage:', itemLocalStorage ? itemLocalStorage.length : 0, 'caracteres');
    console.log('- Info armazenamento:', info);

    alert(`🔍 Debug Estado dos Logs:\n\n` +
          `• Logs no serviço: ${logs.length}\n` +
          `• Logs no componente: ${this.logsListView.length}\n` +
          `• localStorage: ${itemLocalStorage ? 'Existe' : 'Vazio'}\n` +
          `• Tamanho: ${itemLocalStorage ? itemLocalStorage.length : 0} caracteres`);
  }

  /**
   * Método para forçar limpeza completa (método mais agressivo)
   */
  forcarLimpezaCompleta(): void {
    if (!confirm('🚨 LIMPEZA FORÇADA\n\nEste método irá forçar a limpeza completa de todos os logs usando múltiplas estratégias.\n\nContinuar?')) {
      return;
    }

    try {
      // Estratégia 1: Usar o método do serviço
      this.diagnosticoWhatsappService.limparTodosLogsCompleto();

      // Estratégia 2: Limpar localStorage diretamente
      const storageKey = 'diagnostico_whatsapp_logs';
      localStorage.removeItem(storageKey);

      // Estratégia 3: Limpar todas as chaves relacionadas
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.includes('diagnostico') || key.includes('whatsapp') || key.includes('logs')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(key => localStorage.removeItem(key));

      // Estratégia 4: Limpar variáveis do componente
      this.logsListView = [];
      this.logsListViewFiltrados = [];
      this.conteudoRelatorio = '';
      this.conteudoRelatorioFormatado = '';
      this.totalLogs = 0;
      this.estatisticas = { sucessos: 0, erros: 0, avisos: 0, processamentos: 0 };
      this.filtroTipo = 'TODOS';
      this.filtroCategoria = 'TODAS';
      this.textoBusca = '';

      // Verificação final
      setTimeout(() => {
        const logsRestantes = this.diagnosticoWhatsappService.obterTodosLogs();
        const itemLocalStorage = localStorage.getItem(storageKey);

        if (logsRestantes.length === 0 && !itemLocalStorage) {
          alert('✅ Limpeza forçada concluída com sucesso!\n\nTodos os logs foram removidos.');
        } else {
          alert('⚠️ Limpeza forçada parcialmente bem-sucedida.\n\nVerifique o console para mais detalhes.');
        }

        console.log('[VerContatoIframe] Limpeza forçada concluída');
        console.log('- Logs restantes no serviço:', logsRestantes.length);
        console.log('- localStorage:', itemLocalStorage ? 'Ainda existe' : 'Limpo');
        console.log('- Chaves removidas:', keysToRemove);
      }, 100);

    } catch (error) {
      console.error('[VerContatoIframe] Erro na limpeza forçada:', error);
      alert('❌ Erro na limpeza forçada. Verifique o console.');
    }
  }

  private carregueImpressorasConfiguradas(): void {
    const impressoras = this.empresa?.configImpressao?.impressoras || [];
    this.impressorasConfiguradas = impressoras.filter((impressora: any) => impressora && !impressora.removida);
  }

  private obtenhaImpressoraPadrao(): any {
    return this.impressorasConfiguradas[0] || null;
  }

  private obtenhaLayoutPadrao(impressora: any = null): string {
    let layout = impressora?.layout || this.empresa?.configImpressao?.layoutPedido;

    if(layout === 'Ambos')
      return 'PedidoCompleto';

    return layout;
  }
}
